/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import "./TableHeaderFilter.scss";

// Redux
import { useSelector } from "react-redux";

const index = (props) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  return (
    <React.Fragment>
      <div
        id={props.id}
        className={`filter-item mr-1 py-auto ${props.isActive && "active"} ${mainTheme === "dark" && "dark"}`}
        // className={
        //   mainTheme === "dark"
        //     ? !props.isActive
        //       ? "filter-item-dark mx-1 py-auto"
        //       : "filter-item-dark mx-1 py-auto filter-item-active-dark "
        //     : !props.isActive
        //     ? "filter-item-light mx-1 py-auto"
        //     : "filter-item-light mx-1 py-auto filter-item-active-light "
        // }
        onClick={props.onClick}
      >
        <span
          className="text-muted"
        >
          <img
            src={props.statusPath}
            className="mr-2"
            alt="agente-quantity-status"
          />
          {props.quantity}
        </span>
      </div>
    </React.Fragment>
  );
};

export default index;
